import {v3, v2, quat} from "oc-threejs/short3.js";
import Commons from "oc-commons/Commons";

/**
 * Basisklasse für alle Snaps. Ein Snap positioniert ein Objekt an einer Stelle, abhängig von
 * der Position des Objektes und nicht von der ursprünglichen Drag-Position.
 * Somit können mehrere Snaps zugleich wirken, was an Schnittpunkten von Linien interessant wird.
 */
export default class Snap {

    /** @type {?THREE.Object3D} */
    parentObject3D;
    /** @type {THREE.Matrix4} */
    matrixWorld;
    /** @type {THREE.Matrix4} */
    matrixWorldInverse;
    /** @type {?THREE.Object3D} */
    dragObject3d;
    /** @type {?THREE.Box3} */
    dragObject3dBoundingBoxLocal;
    /** @type {?THREE.Object3D} */
    visualization;
    /** @type {string} */
    name;

    /** */
    constructor(options) {
        this.parentObject3D = (options && options.parentObject3D) || null;
        this.matrixWorld = (options && options.matrixWorld)
            || (this.parentObject3D && this.parentObject3D.matrixWorld.clone())
            || new THREE.Matrix4();
        this.matrixWorldInverse = new THREE.Matrix4().getInverse(this.matrixWorld);
        this.name = (options && options.name) || Commons.typeName(this);
        // ab welcher Distanz fängt der Snap das Objekt ein?
        this.radiusSnapStart = options.radiusSnapStart ? options.radiusSnapStart : STAGE.settings.dragDrop.radiusSnapStart;
        // ab welcher Distanz gibt der Snap das Objekt wieder frei? Hier ein größerer Wert als radiusSnapStart,
        // um ein "Klebegefühl" zu erreichen, was normalerweise gewollt ist
        this.radiusSnapEnd = options.radiusSnapEnd ? options.radiusSnapEnd : STAGE.settings.dragDrop.radiusSnapEnd;
    }

    /**
     * @param {THREE.Object3D} dragObject3d
     * @param {THREE.Box3} dragObject3dBoundingBoxLocal
     */
    setDragObject3d(dragObject3d, dragObject3dBoundingBoxLocal) {
        this.dragObject3d = dragObject3d;
        this.dragObject3dBoundingBoxLocal = dragObject3dBoundingBoxLocal;
    }

    /**
     * prüft, ob dieser Snap gültig ist
     */
    accept() {
        return true;
    }

    /**
     * Führt den Snap aus. Hier ist man komplett frei, was der Snap letztlich tut,
     * aber normalerweise wird dragged.position auf point gesetzt.
     * @param dropped Boolean, false für drag und true für drop
     * @returns Boolean, ob der Snap tatsächlich aktiv ist
     */
    perform(dropped) {
        return false;
    }

    /**
     * erzeugt eine Debug-Object3D-Representation, um den Snap anzuzeigen, und gibt das Debug-Objekt3D zurück
     */
    showForDebug() {
        return null;
    }

    /**
     * @param {THREE.Object3D} dragObject3d
     * @param {THREE.Box3} dragObject3dBoundingBoxLocal
     */
    setDragObject3d(dragObject3d, dragObject3dBoundingBoxLocal) {
        this.dragObject3d = dragObject3d;
        this.dragObject3dBoundingBoxLocal = dragObject3dBoundingBoxLocal;
    }

    /**
     * wird beim drop des gedraggte Objektes aufgerufen, wenn der Restraint aktiv ist
     */
    onDrop() {
    }

    /**
     * wird aufgerufen, sobald der Einflussbereich des Restraints betreten wird und der Restraint aktiv wird.
     * Achtung! Wird erst nach perform aufgerufen! Wird auch aufgerufen, wenn das Objekt vor dem DragStart schon im Einflussbereich war.
     */
    onEnter() {
    }

    /**
     * wird aufgerufen, sobald der Einflussbereich des Restraints verlassen wird und der Restraint inaktiv wird,
     * @param real true wenn das gedraggte Objekt wirklich den Einflussbereich verlassen hat, false wenn es im Einflussbereich gedropped wurde
     *        oder es sich um eine Aufräumaktion als Teil des dragEnd handelt
     */
    onLeave(real) {
    }

    /**
     * onDrag3dSceneEnter wird als Teil des normalen Lifecycles bei jedem
     * Drag-Vorgang geworfen.
     */
    onDrag3dSceneEnter() {
    }

    /**
     * wird beim Verlassen der Szene aufgerufen, siehe onDrag3dSceneEnter
     * @param real true if the mouse goes to the outside
     */
    onDrag3dSceneLeave(real) {
    }

    /**
     * wird beim Start des Dragvorganges aufgerufen
     */
    onDrag3dBegin() {
    }

    /**
     * wird beim Ende des Dragvorganges aufgerufen
     */
    onDrag3dEnd() {
    }


    /**
     * wird bei jedem Dragvorgang aufgerufen, wenn der Restraint gültig ist, und zwar garantert nach onEnter, im Gegensatz
     * zu perform. Die Position ist dann auch schon die endgültige.
     */
    onDrag3d() {
    }

    /**
     * erzeugt eine Object3D-Representation, um den Restraint anzuzeigen, und gibt das Objekt3D zurück
     * @returns {?THREE.Object3D}
     */
    createVisualization(restraintHandler) {
        return null;
    }

    /**
     * erzeugt eine Debug-Object3D-Representation, um den Restraint anzuzeigen, und gibt das Debug-Objekt3D zurück
     * @returns {?THREE.Object3D}
     */
    createDebugVisualization(restraintHandler) {
        return null;
    }

}
